import * as React from "react";

export interface ProductImageProps extends Omit<React.ImgHTMLAttributes<HTMLImageElement>, "src" | "srcSet"> {
    className?: string;
    fallbackSrc?: string;
    srcSet: string;
    sizes?: string;
    loading?: React.ImgHTMLAttributes<HTMLImageElement>["loading"];
    ref?: React.Ref<HTMLImageElement>;
    width?: string | number;
    height?: string | number;
}

const ProductImage: React.FC<ProductImageProps> = React.forwardRef(
    ({ fallbackSrc, loading = "lazy", ...props }, ref) => {
        return <img ref={ref} src={fallbackSrc} loading={loading} {...props} />;
    }
);

export default ProductImage;
